<template>
  <v-container fill-height fluid class="pt-0 pb-0">
    <v-row class="chat-container">
      <v-col cols="4" class="fill-height chat-row">
        <v-card>
          <v-card-title>Filters</v-card-title>
          <v-card-text>
            <v-date-picker
                v-model="date"
                full-width
                elevation="15"
                class="mb-4"
                @change="loadChats"
            ></v-date-picker>

            <v-autocomplete :label="date ? 'Account' : 'Select Date First'" @change="loadMessages" :items="accounts" v-model="displayID" :disabled="!date" outlined hide-details></v-autocomplete>

            <v-btn
              block color="orange" class="mt-2"
              :loading="loadingDayDownload"
              :disabled="!date || (!accounts || !accounts.length)"
              @click="downloadDayMessages">Download Day Chats</v-btn>

            <v-btn
              block color="primary" class="mt-2"
              :loading="loadingDownload"
              :disabled="(!messages || !messages.length) || !displayID"
              @click="downloadMessages">Download {{ displayID || '?' }} Chat</v-btn>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="8">
        <chat-history :messages="messages" :rooms="rooms" :displayID="displayID" :loading="loading"></chat-history>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ChatHistory from "./ChatHistory";
export default {
  name: "ArchivePage",
  components: {ChatHistory},
  data() {
    return {
      messages: [],
      rooms: {},
      displayID: "",
      date: "",
      loading: false,
      accounts: [],

      loadingDayDownload: false,
      loadingDownload: false,
    }
  },

  computed: {

  },

  mounted() {

  },

  methods: {
    loadChats() {
      if (!this.date) return;

      let url = `/api/chats?full_day=1`;
      if (this.date) {
        url += `&ts=${new Date(this.date).getTime() / 1000}`;
      }

      this.accounts = [];

      this.$axios.get(url).then((res) => {
        const data = res.data;

        this.accounts = data.accounts;
      })
    },

    loadMessages() {
      if (!this.displayID || !this.date) return;

      let url = `/api/chat_messages?displayID=${this.displayID}&full_day=1`;
      if (this.date) {
        url += `&ts=${new Date(this.date).getTime() / 1000}`;
      }

      this.messages = [];
      this.rooms = {};

      this.loading = true;

      this.$axios.get(url).then((res) => {
        const data = res.data;

        this.rooms = data.room_infos;

        let roomId = null;

        for (let message of data.messages) {
          if (message.data.roomId !== roomId) {
            this.messages.push({
              'type': 'room',
              'ts': message.server_ts ? new Date(message.server_ts * 1000) : new Date(),
              'text': '',
              'room_id': message.data.roomId,
              'name': '',
              'read': true,
              '_id': message._id
            })
          }

          roomId = message.data.roomId;

          this.addMessage(this.messages, message);
        }

        // update clubmgmt account list if account not in there
        this.$store.commit('addClubmgmAccount', data.mgmt_account);

        this.loading = false;
      }).catch((err) => {
        console.error(err);
      })
    },

    downloadDayMessages() {
      if (!this.date) return;

      let url = `/api/download_day_chat_messages?`;
      if (this.date) {
        url += `&ts=${new Date(this.date).getTime() / 1000}`;
      }

      this.loadingDayDownload = true;

      this.$axios.get(url, {responseType: 'blob'}).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.date}_messages.zip`);
        document.body.appendChild(link);
        link.click();

        this.loadingDayDownload = false;
      }).catch(err => {
        console.error(err);
      })
    },

    downloadMessages() {
      if (!this.displayID || !this.date) return;

      let url = `/api/download_chat_messages?displayID=${this.displayID}&full_day=1`;
      if (this.date) {
        url += `&ts=${new Date(this.date).getTime() / 1000}`;
      }

      this.loadingDownload = true;

      this.$axios.get(url).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.displayID}_${this.date}_messages.csv`);
        document.body.appendChild(link);
        link.click();

        this.loadingDownload = false;
      }).catch(err => {
        console.error(err);
      })
    },

    addMessage(messages, payload) {
      let msg = payload.data;
      let server_ts = payload.server_ts;
      let ts = new Date();
      if (server_ts) {
        ts = new Date(server_ts * 1000);
      }

      let read = Boolean(msg.read);
      messages.push({
        'type': payload.type || 'group',
        'ts': ts,
        'text': msg.text,
        'name': msg.displayName,
        'name_mentions': msg.name_mentions,
        'dev_only': msg.dev_only,
        'is_debug': msg.is_debug,

        // voice chat
        'filename': msg.filename,

        // gift chat
        'giftId': msg.giftId,
        'targetName': msg.targetName,
        'targetIsBot': msg.targetIsBot,

        // emoji chat
        'emojiId': msg.emojiId,

        'read': read,
        'result': msg.result || 0,
        'senderName': msg.sent_by ? msg.sent_by.user : null,
        'hand_num': payload.type === "handend" ? msg.hand_num || -1 : -1,
        'group': msg.group !== false,
        'senderId': msg.senderId,
        'senderType': msg.senderType,
        '_id': payload._id
      });
    },
  }
}
</script>

<style scoped>
.chat-container {
  height: calc(100vh - 48px) !important;
  max-height: calc(100vh - 48px) !important;
  /*overflow: hidden;*/
}

.chat-container > div {
  height: 100%;
}

.chat-row {
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
</style>
